<template>
  <div>
    <el-row :gutter="20">
      <el-col :span="12">
        <div style="color: #fccc66; line-height: 30px">企业数量和质量</div>
        <entity-mode-ratio></entity-mode-ratio>
      </el-col>
      <el-col :span="11">
        <certification-zone></certification-zone>
      </el-col>
      <el-col :span="24">
        <certification-scroller></certification-scroller>
      </el-col>
    </el-row>
    <el-row style="margin-top: 20px">
      <el-col :span="24">
        <div style="color: #fccc66; line-height: 30px">投入品使用量</div>
        <inputs-zone></inputs-zone>
      </el-col>
    </el-row>
    <el-row>
      <!-- 乡镇企业数排名 -->
      <el-col :span="24">
        <div style="color: #fccc66; line-height: 30px">乡镇企业数排名</div>
        <entity-amount-rank></entity-amount-rank>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import EntityModeRatio from './entity-mode-ratio.vue'
import CertificationZone from './certification-zone.vue'
import CertificationScroller from './certification-scroller.vue'
import EntityAmountRank from './entity-amount-rank.vue'
import InputsZone from './inputs-zone.vue'
export default {
  components: {
    EntityAmountRank,
    EntityModeRatio,
    CertificationScroller,
    CertificationZone,
    InputsZone,
  },
  data() {
    return {}
  },
}
</script>


// WEBPACK FOOTER //
// src/components/screen38496/administration-zone/index.vue